import React from 'react';
import TimesheetDetailTimeButton from './TimesheetDetailTimeButton';
import TimesheetDetailContractPhaseButton from './TimesheetDetailContractPhaseButton';
import TimesheetDetailTimeDisplay from './TimesheetDetailTimeDisplay';
import cls from 'classnames';

export default class TimesheetDetailRow extends React.Component {
    render() {
        const { loading, timesheetDetail, timesheet } = this.props;

        if (loading || !timesheetDetail) {
            return null;
        }

        const { employee, equipment } = timesheetDetail;

        const isAttachedEquipment = equipment?.id > 0;

        return (
            <div
                className={cls(
                    'timesheet-detail-row',
                    'd-flex',
                    'phase-grid-row',
                    {
                        'equipment-row': isAttachedEquipment,
                    }
                )}
            >
                <div
                    className={cls('col-2', 'phase-grid-left-col', {
                        'd-flex': isAttachedEquipment,
                    })}
                >
                    {isAttachedEquipment && <div className="elbow-div"></div>}

                    <div>
                        <TimesheetDetailTimeButton
                            {...this.props}
                            employee={employee}
                            equipment={equipment}
                        />
                    </div>
                </div>

                {timesheet.timesheetContractPhases.map((tcp) => {
                    const timesheetDetailContractPhaseAdjustment =
                        timesheetDetail.timesheetDetailContractPhaseAdjustments.find(
                            (tdcpa) =>
                                tdcpa.contractPhaseId == tcp.contractPhaseId
                        );

                    if (timesheetDetailContractPhaseAdjustment) {
                        return (
                            <TimesheetDetailContractPhaseButton
                                key={`tdcpbda-${timesheetDetailContractPhaseAdjustment.contractPhaseId}-${timesheetDetailContractPhaseAdjustment.timesheetDetailId}`}
                                timesheetDetailContractPhaseAdjustment={
                                    timesheetDetailContractPhaseAdjustment
                                }
                                {...this.props}
                            />
                        );
                    }

                    const timesheetDetailContractPhase =
                        timesheetDetail.timesheetDetailContractPhases.find(
                            (tdcp) =>
                                tcp.contractPhaseId == tdcp.contractPhaseId
                        );

                    return (
                        <TimesheetDetailContractPhaseButton
                            key={`tdcpbd-${timesheetDetailContractPhase.contractPhaseId}-${timesheetDetailContractPhase.timesheetDetailId}`}
                            timesheetDetailContractPhase={
                                timesheetDetailContractPhase
                            }
                            {...this.props}
                        />
                    );
                })}

                {timesheet.timesheetContractPhaseAdjustments
                    .filter(
                        (tcpa) =>
                            !timesheet.timesheetContractPhases.some(
                                (tcp) =>
                                    tcpa.contractPhaseId == tcp.contractPhaseId
                            )
                    )
                    .map((tcpa) => {
                        const timesheetDetailContractPhaseAdjustment =
                            timesheetDetail.timesheetDetailContractPhaseAdjustments.find(
                                (tdcpa) =>
                                    tdcpa.contractPhaseId ==
                                    tcpa.contractPhaseId
                            ) ?? {
                                contractPhaseId: tcpa.contractPhaseId,
                                quantity: 0,
                                timesheetDetailId: timesheetDetail.id,
                            };

                        return (
                            <TimesheetDetailContractPhaseButton
                                key={`tdcpbdadj-${timesheetDetailContractPhaseAdjustment.contractPhaseId}-${timesheetDetailContractPhaseAdjustment.timesheetDetailId}`}
                                timesheetDetailContractPhaseAdjustment={
                                    timesheetDetailContractPhaseAdjustment
                                }
                                {...this.props}
                            />
                        );
                    })}

                <div className="grid-col"></div>

                <div className="grid-col phase-grid-right-col">
                    <TimesheetDetailTimeDisplay {...this.props} />
                </div>
            </div>
        );
    }
}
